module.exports = __webpack_public_path__ + "static/Beauty-pie-b32561711461a328c67f6d9283770de4.svg";